<template>
    <div class="message"
         :class="'from-'+(message.manager_id ? 'manager' : 'client')"
    >
        <div v-if="message.manager_id"  class="avatar">
            <img :src="favicon" alt="">
        </div>
        <div class="text">
            <span v-if="message.manager_id" class="agent label__large">Agent</span>
            <div class="text-content body__medium">
                <div v-html="convertText(message.text)"></div>
                <div v-if="['.jpg', '.png', 'jpeg'].indexOf(message.file.slice(-4)) > -1"
                     @click="openImg(restEndpoint+'/kyc/document/'+message.file)"
                     class="pic"
                >
                    <img :src="restEndpoint+'/kyc/document/'+message.file">
                </div>
                <a v-if="message.file.slice(-4) === '.pdf'"
                   :href="restEndpoint+'/kyc/document/'+message.file"
                   class="pdf" target="_blank"
                >
                    <i class="material-icons">attach_file</i> PDF attachment
                </a>
            </div>
            <div class="footer">
                <div class="time">{{ new Date(message.time_created * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }) }}</div>
<!--                <slot name="copy" :message="message"/>-->
            </div>
        </div>
    </div>
</template>

<script>
import {FAVICON, REST_ENDPOINT} from "@/common/config"

export default {
    name: "MessageBox",
    props: {
        message: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            restEndpoint: REST_ENDPOINT,
            favicon: FAVICON
        }
    },
    methods: {
        convertText(text) {
            let objRE = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
            return text.replace(objRE, url => '<a style="color: var(--white); word-break: break-word;" target="_blank" href="' + url + '">' + url + '</a>')
        },
        openImg(path) {
            this.path[0] = path
            this.toggler = !this.toggler
        },
    }
}
</script>

<style scoped>
.message {
    display: flex;
    position: relative;
    margin-bottom: 10px;
    gap: 10px;
    overflow: hidden;
}

.message:last-child {
    margin-bottom: 0;
}

.message.from-manager {
    justify-content: flex-start;
}

.message.from-client {
    justify-content: flex-end;
}

.avatar {
    min-width: 40px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: #000;
}

.avatar img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    border-radius: 100%;
}

.message.from-manager .avatar {
    grid-area: 1/1;
}

.message.from-manager .text-content {
    background: var(--System-Surface5);
    padding: 10px 16px;
    border-radius: 0 var(--Corner-small) var(--Corner-small) var(--Corner-small);
}

.message.from-client .text-content {
    background: var(--System-PrimaryContainer);
    padding: 12px 16px;
    border-radius: var(--Corner-small) 0 var(--Corner-small) var(--Corner-small);
}

.message.from-manager .footer {
    justify-content: flex-end;
}

.message.from-client .footer {
    justify-content: flex-start;
}

.text {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.agent {
    color: var(--System-OnSurface);
}

.text-content {
    color: var(--System-OnSecondaryContainer);
    word-break: break-all;
    position: relative;
}

.footer {
    display: flex;
    gap: 5px;
}
</style>
